import { ChangePasswordSuccessPage } from "./ChangePasswordSuccessPage";

export const SetupPasswordSuccessPage = () => {
  return <ChangePasswordSuccessPage mode="setup" />;
};
